import(/* webpackMode: "eager" */ "/home/jihad/Torongo-Gadgets/torongo-frontend/node_modules/next/dist/client/app-dir/link.js");
